
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .then(() => {
    // Defer Swiper element registration to after bootstrap to reduce main-thread blocking
    import('swiper/element/bundle').then(({ register }) => register());
  })
  .catch((err) => console.error(err));